module.exports = __webpack_public_path__ + "img/bluetooth_smartpen.298a3557.png";